import React, { useRef, useEffect, useState } from "react";
import { Card, Spinner, Row, Col, Container } from "react-bootstrap";
import Chart from "chart.js/auto";
import { toast } from "react-toastify";

interface Props {
  dadosPedidos: any;
  loading: boolean;
  error: string | null;
}

const ValorPedidosPorClienteChart: React.FC<Props> = ({ dadosPedidos, loading, error }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const [chartInstance, setChartInstance] = useState<Chart | null>(null);

  // Notificação de erro
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (dadosPedidos?.vendas_x_cliente && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (!ctx) return;

      const nomesClientes = dadosPedidos.vendas_x_cliente.map((cliente: any) => cliente.NOME_FANTASIA);
      const valoresPedidos = dadosPedidos.vendas_x_cliente.map((cliente: any) => parseFloat(cliente.TOTAL_VENDIDO));

      // Remover instância anterior do gráfico
      if (chartInstance) {
        chartInstance.destroy();
      }

      const newChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: nomesClientes,
          datasets: [
            {
              label: "Valor dos Pedidos",
              data: valoresPedidos,
              backgroundColor: [
                "rgba(54, 162, 235, 0.7)", "rgba(255, 99, 132, 0.7)", "rgba(255, 206, 86, 0.7)",
                "rgba(75, 192, 192, 0.7)", "rgba(153, 102, 255, 0.7)", "rgba(255, 159, 64, 0.7)"
              ],
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "Valor (R$)" },
            },
          },
          plugins: {
            legend: { position: "top" },
          },
        },
      });

      setChartInstance(newChart);
    }
  }, [dadosPedidos]);

  return (
    <Card className="p-3 shadow" style={{minHeight: "300px"}}>
      <h5 className="text-center mb-3">Valor dos Pedidos por Cliente</h5>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p>Carregando dados...</p>
        </div>
      ) : (
        <div className="ratio ratio-16x9">
          <canvas ref={chartRef}></canvas>
        </div>
      )}
    </Card>
  );
};

export default ValorPedidosPorClienteChart;
